/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { ChromePicker } from 'react-color';

import {
    commonDefaultProps,
    commonPropTypes,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'input',
    type: 'text',
};

const FormInputColor = (props) => {
    const [displayColorPicker, setDisplayColorPicker] = useState(false);

    const toggleColorPicker = () => {
        setDisplayColorPicker((prevState) => !prevState);
    };

    const closeColorPicker = () => {
        setDisplayColorPicker(false);
    };

    const onColorPickerChange = (color) => {
        if (!props.onChange) return;
        props.onChange(color.hex);
    };

    const onInputChange = (e) => {
        props.onChange(e.target.value);
    };

    const renderColorPicker = () => {
        if (!displayColorPicker) return null;
        return (
            <>
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    }}
                    onClick={closeColorPicker}
                />
                <div
                    style={{
                        position: 'absolute',
                        top: '42px',
                        zIndex: 3,
                    }}
                >
                    <ChromePicker
                        color={props.value}
                        onChangeComplete={onColorPickerChange}
                    />
                </div>
            </>
        );
    };

    return (
        <>
            <div
                {...filterProps(propTypes, props)}
                className="c-form-input c-form-field__colorpicker--color"
                onClick={toggleColorPicker}
            >
                <div
                    style={{
                        backgroundColor: props.value,
                        height: '20px',
                        width: '20px',
                        position: 'relative',
                        top: '-2px',
                        left: '-2px',
                        borderRadius: '10px',
                        border: '1px solid #E8EAED',
                    }}
                />
            </div>
            <input
                type="text"
                placeholder="#eb66ce"
                {...filterProps(propTypes, props)}
                className="c-form-input"
                onChange={onInputChange}
            />
            {renderColorPicker()}
        </>
    );
};

FormInputColor.propTypes = propTypes;

FormInputColor.defaultProps = defaultProps;

export default FormInputColor;
